export const downloadBroucher = async () => {
  const alink = document.createElement('a')
  alink.href = "https://spinlaunch.one/Brochure.pdf"
  alink.target = '_blank'
  alink.download = 'Spin1-Brochure.pdf'
  alink.click()
}